<template>
  <div class="past-payments">
    <!-- Actions -->
    <div class="form-actions flex justify-between separated-section py-0">
      <div class="flex vx-col-action">
        <vs-input icon-pack="feather" icon="icon-search" placeholder="Type here..." v-model="searchText" class="is-label-placeholder searchBar-input" id="filter-text-box" v-on:input="onFilterTextBoxChanged()" />
        <span class="br-line mr-2 ml-2"></span>
      </div>

      <div class="float-right flex">
				<vx-tooltip text="Download List" position="top">
					<vs-button class="iconOnly" color="dark" type="flat" icon-pack="feather" icon="icon-download" @click="downloadData()"></vs-button>
				</vx-tooltip>
				<vx-tooltip text="Reset Filters" position="top">
					<vs-button class="iconOnly" color="dark" type="flat" icon-pack="feather" icon="icon-refresh-ccw" @click="refreshPageWithFilters()"></vs-button>
				</vx-tooltip>
      </div>
    </div>
    <!-- Actions -->

    <!-- AG Grid Data -->
    <div id="grid-loader" class="vx-card vs-con-loading__container">
			<ag-grid-vue :gridOptions="gridOptions" class="ag-theme-material w-100 ag-grid-table reseller-list-grid" :columnDefs="columnDefs" :defaultColDef="defaultColDef" :components="components" :rowData="tableData" rowSelection="multiple" :enableRangeSelection="true" :suppressCopyRowsToClipboard="true" :suppressDragLeaveHidesColumns="true" :animateRows="false" :floatingFilter="true" :pagination="true" :paginationPageSize="paginationPageSize" :suppressPaginationPanel="true" :suppressRowClickSelection="true" :rowClassRules="rowClassRules" :statusBar="statusBar" :sideBar="sideBar" :rowHeight="30" :headerHeight="30" :floatingFiltersHeight="35" :checkboxSelection="true" @filter-changed="onFilterChanged" @row-selected="onRowSelected" @pagination-changed="onPaginationChanged" @column-resized="onColumnResized">
			</ag-grid-vue>

			<!-- Pagination -->
			<div class="vx-row py-5">
				<div class="vx-col w-full">
					<vs-pagination :total="totalPages" :max="maxPageNumbers" class="custom-pagination" v-model="currentPage" />
				</div>
			</div>
      <!-- Pagination -->
    </div>
    <!-- AG Grid Data -->

    <ViewPaymentDetails></ViewPaymentDetails>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-enterprise";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import "@/assets/scss/radix/extraComponents/agGridStyleOverride.scss";

import CellRendererClientViewPaymentDetails from "@/components/ag-grid-tables/actions/CellRendererClientViewPaymentDetails.vue";
import ViewPaymentDetails from "@/components/partner/ViewPaymentDetails.vue";

export default {
  name: 'PastPayments',
  components: {
    AgGridVue,
    CellRendererClientViewPaymentDetails,
    ViewPaymentDetails
  },
  data() {
    return {
      // Actions
      searchText: '',

      // Ag Grid Config
      gridOptions: {},
      gridApi: null,
      columnDefs: null,
      defaultColDef: {
          sortable: true,
          resizable: true,
          suppressMenu: true,
          suppressMovable: false,
          filterParams: {
              suppressAndOrCondition: true,
              newRowsAction: "keep",
          },
      },
      components: null,
      tableData: null,
      rowClassRules: null,
      statusBar: null,
      sideBar: null,

      // Pagination
      maxPageNumbers: 7,

      // Custom
      selectedRowCount: 0,
      flags: {
        selectedAll: []
      }
    }
  },
  beforeMount() {
    this.populateTableData();

    this.toggleColumnMovable(this.windowWidth);

    (this.columnDefs = [
      {
        headerName: 'Period',
        field: 'rebates_summary_data.period',
        filter: 'agSetColumnFilter',
        minWidth: 150,
        width: 250,
        pinned: 'left',
      },
      {
        headerName: 'Payment Mode',
        field: 'rebates_summary_data.payment_mode',
        filter: 'agSetColumnFilter',
        minWidth: 150,
        width: 250,
      },
      {
        headerName: 'Domain Count',
        field: 'rebates_summary_data.domain_count',
        filter: 'agSetColumnFilter',
        minWidth: 150,
        width: 250,
      },
      {
        headerName: 'Rebate Amount',
        field: 'rebates_summary_data.sum_of_rebates',
        filter: 'agSetColumnFilter',
        minWidth: 150,
        width: 250,
      },
      {
        headerName: 'Status',
        field: 'status',
        filter: 'agSetColumnFilter',
        minWidth: 150,
        width: 250,
      },
      {
        headerName: 'Actions',
        field: 'actions',
        filter: 'agSetColumnFilter',
        cellRendererFramework: 'CellRendererClientViewPaymentDetails',
        minWidth: 100,
        width: 100
      }
    ]),
    (this.sideBar = {
      toolPanels: [
        {
          id: "columns",
          labelDefault: "Columns",
          labelKey: "columns",
          iconKey: "columns",
          toolPanel: "agColumnsToolPanel",
          toolPanelParams: {
              suppressRowGroups: true,
              suppressValues: true,
              suppressPivots: true,
              suppressPivotMode: true,
              suppressSideButtons: true,
              suppressColumnSelectAll: true,
              suppressColumnExpandAll: true,
          },
        },
      ],
    });
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.gridApi.showLoadingOverlay();
    this.sizeColumnsToFit();
    this.toggleColumnPinned(this.windowWidth);

    this.$root.$on('downloadClientPastPayments', () => {
      this.gridApi.exportDataAsCsv();
    })
  },
  computed: {
    windowWidth: function () {
      return this.$store.state.windowWidth;
    },
    paginationPageSize() {
      if (this.gridApi) {
          return this.gridApi.paginationGetPageSize();
      } else {
          return 15;
      }
    },
    totalPages() {
      if (this.gridApi) {
          return this.gridApi.paginationGetTotalPages();
      } else {
          return 0;
      }
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
    currentPage: {
      get() {
          if (this.gridApi)
              return this.gridApi.paginationGetCurrentPage() + 1;
          else return 1;
      },
      set(val) {
          this.gridApi.paginationGoToPage(val - 1);
      },
    },
  },
  methods: {
    onFilterTextBoxChanged() {
      this.gridApi.setQuickFilter(document.getElementById("filter-text-box").value);
      this.deselectAllSelectedRows();
    },
    downloadData() {
      this.$root.$emit("downloadClientPastPayments");
    },
    refreshPageWithFilters() {
      this.initSelectedAllFlag();
      // Reset filters
      this.gridApi.setFilterModel(null);
      // Reset selection
      this.gridApi.deselectAll();
      // Reset sort
      this.gridApi.setSortModel(null);
      // Table Data AXIOS Call
      this.populateTableData();
    },
    onFilterChanged() {
      this.deselectAllSelectedRows();
    },
    onRowSelected() {
      var getStatus = this.gridApi
        .getSelectedNodes()
        .map((x) => x.data)
        .map((x) => x.status);

      if (event.node.selected) {
        // Push to selectedPromos
        this.selectedRowCount = this.gridApi.getSelectedNodes().length;
        if (this.selectedRowCount > 30) {
            event.node.setSelected(false);
            this.$vs.notify({
                time: 5000,
                color: "warning",
                title: "Warning",
                text: "You may select only upto 30 rows",
            });
        }
      } else {
        this.selectedRowCount = this.gridApi.getSelectedNodes().length;
      }
    },
    onPaginationChanged() {
      if (this.gridApi) {
        (this.totalRows = this.gridApi.paginationGetRowCount()),
        (this.currentPageSize = this.gridApi.paginationGetPageSize());
      }
    },
    onColumnResized() {
      this.gridApi.resetRowHeights();
    },
    gridSelectAll() {
      this.gridApi.forEachNodeAfterFilter((node) => {
        if (!(    node.data.status == "new approved" || node.data.status == "rejected" || node.data.status == "error")) {
          if (node["rowIndex"] >= (this.currentPage - 1) * this.gridApi.paginationGetPageSize() &&
            node["rowIndex"] < this.currentPage * this.gridApi.paginationGetPageSize()) {
              node.setSelected(true);
          }
        }
      });
    },
    gridDeselectAll() {
      this.gridApi.forEachNodeAfterFilter((node) => {
        if (node["rowIndex"] >= (this.currentPage - 1) * this.gridApi.paginationGetPageSize()
            && node["rowIndex"] < this.currentPage * this.gridApi.paginationGetPageSize()) {
            node.setSelected(false);
        }
      });
    },
    toggleSelectAll() {
      if (this.flags["selectedAll"][this.currentPage - 1]) {
        this.gridDeselectAll();
        this.flags["selectedAll"][this.currentPage - 1] =
            !this.flags["selectedAll"][this.currentPage - 1];
      } else {
          this.selectedRowCount = this.gridApi.getSelectedNodes().length;
          if (this.selectedRowCount < 30 && this.selectedRowCount + 15 <= 30) {
            this.gridSelectAll();
            this.flags["selectedAll"][this.currentPage - 1] =
                !this.flags["selectedAll"][this.currentPage - 1];
          } else {
              this.$vs.notify({
                time: 5000,
                color: "warning",
                title: "Warning",
                text: "You may select only upto 30 rows",
              });
          }
      }
    },

    // Off Page
    openLoadingInDiv() {
      this.$vs.loading({
        container: "#div-with-loading",
        scale: 0.8,
      });
    },
    hideLoadingInDiv() {
      this.$vs.loading.close("#div-with-loading > .con-vs-loading");
    },
    toggleColumnMovable(val) {
      if (val <= 576) {
        this.defaultColDef["suppressMovable"] = true;
      } else {
        this.defaultColDef["suppressMovable"] = false;
      }
    },
    toggleColumnPinned(val) {
      if (val <= 576) {
        this.maxPageNumbers = 4;
        this.gridOptions.columnApi.setColumnPinned("reseller_name", null);
        this.gridOptions.columnApi.setColumnPinned("actions", null);
      } else {
        this.gridOptions.columnApi.setColumnPinned("reseller_name", "left");
        this.gridOptions.columnApi.setColumnPinned("actions", "right");
      }
    },
    sizeColumnsToFit() {
      this.gridApi.sizeColumnsToFit();
    },

    // Helpers
    initSelectedAllFlag() {
      if (this.tableData.length) {
        for (let i = 0; i < this.gridApi.paginationGetTotalPages(); i++) {
          this.flags["selectedAll"].push(false);
        }
      }
    },
    populateTableData() {
      // TODO: Change API to GET all Past Payments
      this.$axiosSecureClient
      .get(`/past-payments/${localStorage.getItem('loggedInPartnerId')}`)
      .then((response) => {
        response.data = response.data.map(x => { 
          x.rebates_summary_data = x.rebates_summary_data[0];
          return x; 
        });

        this.tableData = response.data;

        if (this.gridApi) {
          setTimeout(() => {
              this.initSelectedAllFlag();
          }, 1000);
        }
      })
      .catch((error) => {
        // this.$vs.notify({
        //     color: "danger",
        //     title: "Something went wrong",
        //     text: "Please contact the server admin",
        // });
      });
    },
  },
  destroyed() {
    this.$root.$off('downloadClientPastPayments');
  }
}
</script>

<style scoped>

</style>